module.exports = __webpack_public_path__ + "img/card_availableservices.1a0787e8.svg";